import React, { useState } from "react";
import { KIND_COLOR } from "../lib/theme";

function Highlight({ term, kind, tip }) {
  const [open, setOpen] = useState(false);
  const color = KIND_COLOR[kind] || KIND_COLOR.concept;
  return (
    <span
      className="relative inline-block cursor-help font-medium"
      style={{ color, borderBottom: `1px dashed ${color}` }}
      tabIndex={0}
      data-testid="lesson-highlight"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
      onClick={() => setOpen((o) => !o)}
    >
      {term}
      {open && tip && (
        <span
          className="absolute left-1/2 bottom-full z-30 mb-2 w-56 -translate-x-1/2 rounded-md border p-2 text-xs font-normal leading-snug text-ink shadow-xl anim-fade-up"
          style={{ background: "#1b2029", borderColor: color, color: "#E6E8EE" }}
        >
          <span className="font-mono text-[10px] uppercase tracking-wide" style={{ color }}>{kind}</span>
          <span className="mt-1 block">{tip}</span>
        </span>
      )}
    </span>
  );
}

// Parses [[term|kind|tooltip]] markup and renders paragraphs.
export default function MarkedText({ text, className = "" }) {
  if (!text) return null;
  const paragraphs = text.split(/\n{1,}/).filter((p) => p.trim().length);
  const render = (para, pi) => {
    const parts = [];
    const regex = /\[\[([^\]|]+)\|([^\]|]+)\|([^\]]+)\]\]/g;
    let last = 0;
    let m;
    let i = 0;
    while ((m = regex.exec(para)) !== null) {
      if (m.index > last) parts.push(<span key={`t${pi}-${i}`}>{para.slice(last, m.index)}</span>);
      parts.push(<Highlight key={`h${pi}-${i}`} term={m[1].trim()} kind={m[2].trim()} tip={m[3].trim()} />);
      last = regex.lastIndex;
      i++;
    }
    if (last < para.length) parts.push(<span key={`e${pi}`}>{para.slice(last)}</span>);
    return parts;
  };
  return (
    <div className={className}>
      {paragraphs.map((p, pi) => (
        <p key={pi} className="mb-3 last:mb-0 leading-relaxed text-ink/90">{render(p, pi)}</p>
      ))}
    </div>
  );
}
